import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Customer, CustomerAccount } from '@inyova/models';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromReporting from '@reporting/reporting.reducers';

import { ReportEndValues } from '@shared/models/Reporting';

@Component({
  selector: 'app-reporting-header',
  templateUrl: './reporting-header.component.html',
  styleUrls: ['./reporting-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ReportingHeaderComponent implements OnDestroy {
  private readonly onDestroy$ = new Subject<void>();
  @Input() customer: Customer;
  @Input() currentAccount: CustomerAccount;
  @Input() daysDifference: number;
  endValues: ReportEndValues;
  loading = true;

  constructor(private store: Store) {
    this.store.pipe(select(fromReporting.selectEndValues), takeUntil(this.onDestroy$)).subscribe((endValues) => {
      this.endValues = undefined; // TODO make this better assigning undefined isn't nice approach
      if (!endValues || !endValues.end_date) {
        return;
      }
      this.endValues = endValues;
    });
    this.store.pipe(select(fromReporting.selectIsInitialised), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.loading = !value;
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
